import { BasicMetaData } from "../../model/wfl/basic-metadata";
import { Category } from "../../model/wfl/category";
import { ContentMetaData } from "../../model/wfl/content-metadata";
import { MetaData } from "../../model/wfl/metadata";
import { Publication } from "../../model/wfl/publication";
import { SourceMetaData } from "../../model/wfl/source-metadata";
import { State } from "../../model/wfl/state";
import { WflObject } from "../../model/wfl/wflobject";
import { WorkflowMetaData } from "../../model/wfl/workflow-metadata";

export class WflHelpers {    
    /**
     *
     * @param name
     * @param type The object type like 'Article'
     * @param categoryId
     * @param publicationId
     * @param stateId
     *
     * @returns The Workflow object
     */
    static createWflObject(name: string, type : string | undefined, categoryId: string, publicationId: string, stateId: string) : WflObject {

        return new WflObject({
            Metadata: new MetaData({
                BasicMetaData: new BasicMetaData({
                    Name: name,
                    Type: type,
                    Publication: new Publication({
                        Id : publicationId
                    }),
                    Category: new Category({ 
                        Id: categoryId
                    })
                }),
                WorkflowMetaData: new WorkflowMetaData({
                    State: new State(stateId)
                }),
            }),
            Files: [],
            Relations: []
        });
    }
}